
import { createStore, combineReducers, applyMiddleware } from 'redux';
import thunk from 'redux-thunk';
import reducer from '../Reducer'

let middleware = applyMiddleware(thunk);

const combinedReducers = combineReducers(reducer);

/* eslint-disable no-underscore-dangle */
const compose = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__;
if (compose) {
  middleware = compose(middleware);
}
export default function configureStore(initialState = {}) {
  return createStore(combinedReducers, initialState, middleware);
}
/* eslint-enable */
